import { FunctionComponent, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import { observer } from "mobx-react-lite";

import { BreadCrumb } from "primereact/breadcrumb";
import { MenuItem } from "primereact/menuitem";

import { faHome } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { useStore } from "../../../stores/StoreContext";

import "./Breadcrumb.scss";

const RawBreadcrumbComponent: FunctionComponent = () => {
  const { t } = useTranslation();
  const { navigationStore, userStore } = useStore();

  const [activeMenuItems, setActiveMenuItems] = useState<MenuItem[]>([]);

  const menuItemTemplate = () => (
    <Link to={navigationStore.landingPage.url ?? ""}>
      <FontAwesomeIcon icon={navigationStore.landingPage.icon} />
    </Link>
  );

  const homeBread: MenuItem = {
    ...navigationStore.landingPage,
    template: menuItemTemplate,
  };

  useEffect(() => {
    const currentRoute = navigationStore.currentActiveMenuItem;

    if (currentRoute && currentRoute.url !== homeBread.url) {
      const label = t(currentRoute?.breadCrumbTitle ?? navigationStore.pageNotFound.label ?? "");
      setActiveMenuItems([{ label }]);
    } else {
      setActiveMenuItems([]);
    }
  }, [navigationStore.currentActiveMenuItem, userStore.currentLanguage]);

  return (
    <div className="breadcrumb-container">
      {activeMenuItems?.length ? (
        <BreadCrumb model={activeMenuItems} home={homeBread} />
      ) : (
        <div className="root">
          <Link to={navigationStore.landingPage.url ?? ""}>
            <FontAwesomeIcon icon={faHome} />
          </Link>
        </div>
      )}
    </div>
  );
};

export const BreadcrumbComponent = observer(RawBreadcrumbComponent);
